(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["josef-selection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('josef-picker')) {
  customElements.define('josef-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-pick]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-pick]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-result]').forEach(item => { item.hidden = item.dataset.result !== button.dataset.pick; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
